module.exports = __webpack_public_path__ + "img/jr6.a5f7aebe.png";